export const TICKET_SYSTEM_TYPE_DISPLAY_TEXT = {
    AZURE_BOARD: "Azure",
    JIRA: "Jira",
    SERVICE_NOW: "Service Now",
    FRESHSERVICE: "FreshService",
    GITHUB_ISSUES: "GitHub Issues",
    PAGERDUTY: "PagerDuty",
    SHORTCUT: 'Shortcut',
    GITLAB_ISSUES: "GitLab Issues",
    VERSION_ONE: "Digital.ai Agility",
    CONNECT_ALL: "Connect All",
    RALLY: "Rally",
    ZENDESK: "Zendesk",
    ASANA: "Asana",
    ARCHER: "Archer"
}
